import { render, staticRenderFns } from "./UpdateVolumeDiscountDialog.vue?vue&type=template&id=6c135dda"
import script from "./UpdateVolumeDiscountDialog.vue?vue&type=script&lang=js"
export * from "./UpdateVolumeDiscountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports